import React from 'react'
import { checkTranslation, chooseWallpaper, getAppletsAndhubsFromFramesList, translate } from "../../utils/useful";
// import Responsive from '../../components/Responsive';
// import CustomLoader from '../../components/CustomLoader';
// import StagesManager from '../../components/StagesManager';
import FixedView from '../../components/FixedView';
import Modal from '../../components/Modal';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import { bindActionCreators } from 'redux';
import * as actions from '../../stores/actionsList';
import { connect } from 'react-redux'
import HttpServices from '../../utils/Http.services';
import PortalScopeTreeView from '../../components/header/PortalScopeTreeView';




class EnterRoom extends React.Component {



    state = {
        currentPage: 'dashboard',
        isLoader: false,
        enterRoomOptions: [
            { key: "instant", label: '{{lang}}rooms.Start an instant room', img: '/assets/icons/rooms/instant-room.svg', functionClick: "createRoom" },
            { key: "schedule", label: '{{lang}}rooms.Schedule a room', img: '/assets/icons/rooms/schedule.svg', functionClick: "openScheduleModal" },
            { key: "link", label: '{{lang}}rooms.Start an instant room with link', img: '/assets/icons/rooms/link-gray.svg', functionClick: "createRoomLink" },
            { key: "later", label: '{{lang}}rooms.Create a room for later', img: '/assets/icons/rooms/link-later.svg', functionClick: "createLaterRoomLink" }
        ],
        link: false,
        inputFill: false,
        upcomingList: [
            // { name: 'Paityn Carder & Livia Culhane', time: '17:30' },
            // { name: 'Paityn Carder & Livia Culhane', time: '17:30' },
            // { name: 'Paityn Carder & Livia Culhane', time: '17:30' },
        ],
        roomId: '',
        isLoading: false,
    }

    componentDidMount() {
        this.getSchedules()
    }


    componentDidUpdate(prevProps) {
        if (prevProps.scope != this.props.scope) {
            this.setState({ hierarchy: null, frames: null, hubs: null, applets: null, }, () => {
                this.getSchedules()
            })
        }

    }


    getSchedules = () => {

        let body = { limit: 5 }

        let scope = this.state.currentScope ?? this.props.scope
        let page = this.props.page?._id

        if (page) {
            body.frame = page
        }

        if (scope) {
            body[scope.type] = scope?.item?._id
        }

        // console.log(body)

        HttpServices.request('getRoomSchedules', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ upcomingList: fetchResult.info })

        })
    }


    doFunction = (name, prop) => {

        // console.log(this.props.page, this.props.frame)
        this.fixedView.hideView()
        let scope = this.state.currentScope ?? this.props.scope
        if ((scope && scope?.type == 'frame') || this.props.page?._id) {
            if (this[name]) {
                this[name]()
            }
        } else {

            this.setState({ lastCalledFunction: prop })

            this.scopeFixedView.showView()

            if (!this.state.hierarchy) {

                this.fetchScope(() => { })

            }
        }


    }



    createRoom = (later) => {
        this.setState({ isLoading: true, errors: {} })
        let scope = this.state.currentScope ?? this.props.scope
        let frame = scope?.item?._id ?? this.props.page?._id

        // console.log(frame)
        this.props.createRoom(() => {
            this.setState({ isLoading: false })
        }, null, frame)
    }

    createRoomLink = () => {
        this.setState({ link: true })
    }

    openScheduleModal = () => {

        let scope = this.state.currentScope ?? this.props.scope
        // let frame = scope?.item?._id ?? this.props.page?._id

        let info
        if (scope?.type == 'frame') {
            info = { frame: scope?.item?._id }
        }
        console.log(info, scope)

        this.props.changePage('newschedule', info)
    }





    createLaterRoomLink = () => {

        let scope = this.state.currentScope ?? this.props.scope
        let frame = scope?.item?._id ?? this.props.page?._id

        // console.log(frame)
        this.setState({ isLoading: true, errors: {} })
        this.props.createRoom((roomId) => {
            // console.log('roomid is room', roomId)
            this.setState({ roomId }, () => {
                this.scheduleModal.showModal()
            })
            this.setState({ isLoading: false })
        }, true, frame)
    }





    fetchScope() {
        let body = {}
        body.frameType = 'rooms'

        this.setState({ isLoadingScope: true })

        if (this.props.scope) {
            body[this.props.scope.type] = this.props.scope?.item?._id
        }
        // console.log(body)

        HttpServices.request('getMyAppletsType', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingScope: false })

            if (fetchError) {
                return
            }
            let frames = fetchResult.frames ?? []
            let hierarchy = []

            getAppletsAndhubsFromFramesList(frames, (hubs, applets) => {


                for (let h = 0; h < hubs.length; h++) {
                    const hub = hubs[h];
                    let temp = hub
                    temp.children = []
                    temp['type*'] = 'hub'
                    for (let a = 0; a < applets.length; a++) {
                        const applet = applets[a];
                        // console.log(applet, hub)
                        if (applet.hub?._id == hub._id) {
                            let appletFrames = frames.filter((a) => a.applet?._id == applet._id)

                            for (let f = 0; f < appletFrames.length; f++) {
                                let appletFrame = appletFrames[f];
                                appletFrame['type*'] = 'frame'
                            }

                            temp.children.push({
                                ...applet,
                                ...{
                                    children: appletFrames,
                                    'type*': 'applet'
                                }
                            })

                        }
                    }
                    hierarchy.push(temp)

                }
                // console.log(hierarchy)

                this.setState({ hierarchy, frames, hubs, applets, currentAppletName: null })


            })



        })

    }

    changePage = (item) => {

        this.setState({ currentPage: item.key })
    }

    handleChange = (e) => {
        // event.preventDefault();
        this.setState({ textInputValue: e.target.value })
    }

    handleCopy = (item) => {
        let text = 'https://yonnect.com/rooms/' + `${item}`
        navigator.clipboard.writeText(text);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
        // alert('Copied to clipboard!');
    }
    joinRoomByLink = () => {
        let textInputValue = this.state.textInputValue
        textInputValue = textInputValue.replace('https://yonnect.com/rooms/', '')
        // console.log('textInputValue', textInputValue)
        this.props.joinRoomByLink(textInputValue)
        // https://yonnect.com/rooms/06dcs39trmh6

    }



    changeScope = (item, type) => {

        // console.log(this.props.scope)
        this.setState({ currentScope: item ? { item, type } : null }, () => {

            // this.props.functionsHandler(null, 'changeScope', { item, type })
            this.scopeFixedView.hideView()

            let lastCalledFunction = this.state.lastCalledFunction

            this.doFunction(lastCalledFunction?.functionClick, lastCalledFunction)

        })
    }








    render() {
        return (

            <>
                <div className='px-5 pt-5 pb-5 window-content-radius scroll-no-scrollbar h-100' style={{}}>
                    <h2 className="font-size-25 weight-500" style={{ maxWidth: 300 }} >{translate('Enjoy Secure Video & Voice Calls, Privately or in Groups')}</h2>
                    <p className="mt-1 font-size-14 main-c7 mt-2" >{translate('Effortlessly host secure video calls and meetings for work, business, and personal use. Stay connected with confidence and convenience.')}</p>
                    <div className=' mt-3' ref={(el) => (this.currentNode = el)}>
                        <ButtonAnimated bg={'linear-gradient(to right,#9564FE, #7064FE)'} title='Enter Room' icon={'/assets/icons/arrow-right-white.svg'} onClick={() => this.fixedView.showView()} isLoading={this.state.isLoading} />
                        {this.state.link &&
                            <div className='flexc mt-3'>
                                <input className='copyLinkRoom br-30 py-2 px-3 font-size-14' style={{ width: '200px' }} name='link' id='link' placeholder={translate('rooms.Enter a link')} onChange={e => this.handleChange(e)} />
                                {this.state.textInputValue &&
                                    <button className='roomJoinbtn white-bg mld-5 px-4 py-2 br-30 shadow-2' style={{}} onClick={() => this.joinRoomByLink()}>
                                        <p className='font-size-14'>{translate('rooms.Join')}</p>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    <div className='pt-4' >
                        <p className='font-size-15 weight-500 pld-2' style={{}}>{translate('Upcoming meetings')}</p>

                        {this.state.upcomingList.map((item, index) => {
                            return (
                                <div className='w-100 px-3 py-2 br-10 flexcb shadow-2 mt-3' style={{ backgroundColor: '#fff' }}>
                                    <div className='flexc'>
                                        <div className='br-10 mrd-3' >
                                            <p className='font-size-14' style={{}}>{item.title.length < 13 ? item.title : item.title.substring(0, 10) + '...'}</p>
                                        </div>
                                    </div>
                                    <p className='font-size-14 m-2' style={{}}>{this.props.showDate(item.schedule?.startTime)}</p>
                                    <button>
                                        <p className='font-size-14 m-2' style={{ color: '#7064FE' }}>{translate('rooms.Join')}</p>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </div>


                <FixedView ref={(el) => (this.fixedView = el)} nodeRef={this.currentNode} width={280} xOffset={-10} topOffset={0} showFocus={false} zIndex={20}>
                    <div className='sc-1 shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", }}>
                        {this.state.enterRoomOptions.map((prop, index) => {
                            return (
                                <div className=' bb-gray flexc' style={{ justifyContent: 'flex-start' }} key={index}>
                                    <button onClick={() => { this.doFunction(prop.functionClick, prop) }} className='px-2 flexcb py-2 my-1 hover-gray br-6 w-100 h-100'>
                                        <p className='font-size-14 '>{checkTranslation(prop.label)}</p>
                                        <img src={prop?.img} width={20} />
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </FixedView>



                <FixedView ref={(el) => (this.scopeFixedView = el)} nodeRef={this.currentNode} width={280} xOffset={-10} topOffset={0} showFocus={false} zIndex={20}>
                    <div className='sc-1 shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", }}>

                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>

                            <div className='px-1'>
                                <p className='font-size-15 text-semibold'>{translate("Select the frame")}</p>
                                <p className='font-size-12'>{translate("Room will be proceeded from the selected frame")}</p>
                            </div>
                            <PortalScopeTreeView changeScope={this.changeScope} hierarchy={this.state.hierarchy} isLoading={this.state.isLoadingScope} hideFullScope={true} onlyFrame={true} />

                        </div>
                    </div>
                </FixedView>



                <Modal maxWidth={400} className="" ref={(e) => this.scheduleModal = e}  >
                    <div className='bg-white br-20' style={{ overflow: 'hidden' }}>
                        <p className='font-size-15 weight-500 white px-4 pt-4 pb-2' style={{ background: 'linear-gradient(to right,#9564FE, #7064FE)' }}>{translate("rooms.Here's the link to your room")}</p>
                        <p className='font-size-14 px-4 pt-2' style={{ color: 'rgb(95,99,104)' }}>{translate('rooms.Copy-this-link')}</p>
                        <div className='px-3 py-2 br-10 mx-4 flexcb my-4 shadow-2 cursor-pointer' style={{}} onClick={() => this.handleCopy(this.state.roomId)}>
                            <p className='font-size-14 mrd-4' style={{}} >https://yonnect.com/rooms/{this.state.roomId}</p>
                            <img src='/assets/icons/rooms/copy-purple.svg' />
                        </div>
                    </div>
                </Modal>
            </>

        )
    }
}

// export default EnterRoom;
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnterRoom);